import 'jquery-validation';
import 'jquery-validation-unobtrusive';

// Toggles Footer newsletter
var newsletterFormOpened = false;
$('.js-toggle-footer-newsletter').click(function (event) {
    event.preventDefault();
    if (newsletterFormOpened) {
        $('#newsletter-form-toggle').slideUp();
        $('#newsletter-form-toggle').removeClass('is-active');
        $(this).attr("aria-expanded", "false");
        $(this).attr("aria-label", "Open newsletter signup form");
        newsletterFormOpened = false;
    } else {
        $('#newsletter-form-toggle').slideDown();
        $('#newsletter-form-toggle').addClass('is-active');
        $(this).attr("aria-expanded", "true");
        $('#newsletter-form-toggle input[type="text"]')[0].focus();
        newsletterFormOpened = true;
        $(this).hide();
        $(".hidden-subscribe-button").show();
    }
});
$(document).ready(function () {
    var sitekey = $('.g-recaptcha').data('sitekey');
     
    grecaptcha.ready(function () {
        grecaptcha.execute(sitekey, { action: 'submit' })
            .then(function (token) {
                window.onSubmitSubscribe;
            });
    });
    window.onSubmitSubscribe = function () {
        const form = document.getElementById("formNewsLetterSubscribe");
        const data = {};
        const elements = form.elements;
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const name = element.name;
            const value = element.value;
            data[name] = value;
        }
        const hiddenSubscribeButton = document.querySelector(".hidden-subscribe-button");
        hiddenSubscribeButton.disabled = true;
        const subscribeError = document.getElementById("subscribeError");
        subscribeError.innerHTML = "";
        subscribeError.style.display = "none"; // Hide the error element 

        const options = {
            method: 'POST'
        };
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/umbraco/surface/newsletterajax/subscribe/', true);
        xhr.onload = function () {
            if (xhr.status === 200) { // Check for successful response 
                showNewsLetterSubscribeResponse(xhr, null);
            } else {
                showNewsLetterSubscribeResponse(xhr, null);
            }
        };
        xhr.onerror = function (error) {
            showNewsLetterSubscribeResponse(xhr, null);
        };
        const formData = new FormData(form);
        xhr.send(formData);
    }

    window.showNewsLetterSubscribeResponse = function (jsonResponse, statusText) {

        var response = JSON.parse(jsonResponse.responseText);

        if (response.Success === true) {
            const form = document.getElementById("formNewsLetterSubscribe");
            form.querySelectorAll("input").forEach(input => input.value = ""); // Clear form inputs
            form.style.display = "none"; // Hide the form
            document.getElementById("subscribeThanks").style.display = "block"; // Show thank you message
        } else {
            const hiddenSubscribeButton = document.querySelector(".hidden-subscribe-button");
            hiddenSubscribeButton.disabled = false; // Re-enable button

            const subscribeError = document.getElementById("subscribeError");
            subscribeError.innerHTML = `<p>${response.Message}</p>`;
            subscribeError.style.display = "block"; // Show error message
        }
    }
});
